/**
 * Интерфейс загруженного на сервер файла
 */
import {MimeTypeNamespace} from '@namespaces/mime-type.namespace';
import MimeEnums = MimeTypeNamespace.MimeEnums;

export interface UploadedFile {
    /**
     * Id загруженного файла
     */
    file_id: number;

    /**
     * Исходное имя загруженного файла (так, как файл назывался)
     */
    file_name: string;

    /**
     * Ссылка на файл
     */
    file_url: string;

    /**
     * Размер файла в байтах
     */
    file_size: number;

    /**
     * Тип файла
     */
    file_mime_type: MimeEnums;
}

export namespace UploadedFileNamespace {

    /**
     * Получить структуру пустого файла
     * Например, чтобы очистить поле файла, пропатчив его пустым файлом
     */
    export const getEmptyFileStructure = (): UploadedFile => {
        return {
            file_id: null,
            file_url: null,
            file_name: null,
            file_size: null,
            file_mime_type: null,
        };
    };

    /**
     * Получить имена полей структуры файла.
     * Например, чтобы проверить наличие всех полей в форме
     */
    export const getUploadedFileFields = (): string[] => {
        return Object.keys(getEmptyFileStructure());
    };
}


